var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudCheck = function SvgIconCloudCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.707 10.168a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2.25-2.25a1 1 0 0 1 1.414-1.414L13.5 13.96l3.793-3.793a1 1 0 0 1 1.414 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.478 8.041A8.498 8.498 0 0 1 21.01 5.99 8.5 8.5 0 0 1 15 20.5H6.75a6.25 6.25 0 0 1 0-12.5m9.518-2.375A6.5 6.5 0 0 0 8.5 12a1 1 0 1 1-2 0 8.5 8.5 0 0 1 .239-2 4.25 4.25 0 0 0 .011 8.5H15a6.5 6.5 0 0 0 1.268-12.875",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.478 8.041A6 6 0 0 0 6.75 8z"
  }))));
};
export default SvgIconCloudCheck;